// 文件路径建议：src/stores/viewStore.js
import { defineStore } from 'pinia'

export const useViewStore = defineStore('view', {
  state: () => ({
    currentView: 'GameStart',    // 当前主界面组件名（如 MainMenu、Battle、PokeStorage）
    modals: {},                 // 所有模态窗状态，如 { shop: true, draw: false }
    subView: null,               // 子界面（如 Tab 或二级弹窗状态）
  
    isRotated: false,
    toast: {
      show: false,
      message: '',
      type: 'info', // 可选：info, success, error, warning
    }
  
  
  
  }),

  actions: {
    /**
     * 切换主界面（如进入战斗、商店等）
     * @param {string} viewName - 目标视图名
     */
    changeView(viewName) {
      this.currentView = viewName
    },

    /**
     * 打开一个模态窗（如 'shop', 'draw' 等）
     */
    openModal(name) {
      this.modals[name] = true
    },

    /**
     * 关闭指定模态窗
     */
    closeModal(name) {
      this.modals[name] = false
    },

    /**
     * 切换模态窗状态
     */
    toggleModal(name) {
      this.modals[name] = !this.modals[name]
    },


    openToast(message, type = 'info', duration = 2000) {
      this.toast.show = true
      this.toast.message = message
      this.toast.type = type
      setTimeout(() => {
        this.toast.show = false
      }, duration)
    },
  

    setRotated(val) {
      this.isRotated = val
    },


    /**
     * 重置所有界面状态（如返回首页）
     */
    reset() {
      this.currentView = 'MainMenu'
      this.modals = {}
      this.subView = null
    }
  }
})
